import { almacenAxios } from '@/services/Axios';

const resource = '/v1/settings';

export default {
  async getStores() {
    let response = null;
    response = await almacenAxios.get(`${resource}/stores`);
    response = response.data.data;
    return response;
  },

  async getStoreSettings(storeId) {
    let response = null;
    response = await almacenAxios.get(`/v1/stores/${storeId}/settings`);
    response = response.data;
    return response;
  },
};
